import { HOME_API_ENDPOINTS, REQUEST_METHODS } from '@/constants/network'
import { CYS_MAX_CARDS } from '@/constants/unifiedWidgetStack.constants'
import baseFetch from '@/network/baseFetch'
import { getApiDomain } from '@/utils/general/url'
import type { IUnifiedWidgetsApiResponseDataType } from '@/types/unifiedExpandWidgets'

const DEFAULT_UNIFIED_WIDGETS_TIMEOUT_MS = 5000
const UNIFIED_WIDGETS_FALLBACK_DATA: IUnifiedWidgetsApiResponseDataType = []

export interface IFetchUnifiedWidgetsDataParams {
    // comma-separated, e.g. AIR_FUNNEL_JOURNEY,AIR_LOYALTY
    usecases: string
    size?: number
    timeoutMs?: number
}

export const getUnifiedWidgetsDataFromApi = async (
    params: IFetchUnifiedWidgetsDataParams
): Promise<IUnifiedWidgetsApiResponseDataType> => {
    const { timeoutMs = DEFAULT_UNIFIED_WIDGETS_TIMEOUT_MS, usecases, size = CYS_MAX_CARDS } = params

    if (!usecases) {
        console.error('Usecases parameter is required to fetch unified widgets data')
        return UNIFIED_WIDGETS_FALLBACK_DATA
    }

    try {
        let timeoutId: ReturnType<typeof setTimeout> | null = null
        const timeoutData = new Promise<IUnifiedWidgetsApiResponseDataType>(resolve => {
            timeoutId = setTimeout(() => resolve(UNIFIED_WIDGETS_FALLBACK_DATA), timeoutMs)
        })

        const fetchUnifiedWidgetsData = baseFetch<IUnifiedWidgetsApiResponseDataType>({
            url: `${HOME_API_ENDPOINTS.UNIFIED_WIDGETS}?usecases=${usecases}&size=${size}`,
            method: REQUEST_METHODS.GET,
            domain: getApiDomain(),
            headers: {
                caller: 'AIR',
                referer: typeof window !== 'undefined' ? window.location.href : ''
            }
        })

        const result = await Promise.race([fetchUnifiedWidgetsData, timeoutData])

        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        return Array.isArray(result) ? result : UNIFIED_WIDGETS_FALLBACK_DATA
    } catch (e: unknown) {
        console.error('Unified widgets fetch failed:', e)
        return UNIFIED_WIDGETS_FALLBACK_DATA
    }
}
